import { Injectable } from "@angular/core";
import { ConfirmationService } from "primeng/api";

@Injectable()
export class ConfirmationDialogUtils {

    constructor(private confirmationService: ConfirmationService) {
    }

    ohReally(data: {dialogMessage: string, ohYes: () => void, ohNo: () => void, headerText?: string}) {
        this.confirmationService.confirm({
            message: data.dialogMessage,
            header: data.headerText || $localize `Are you sure?`,
            rejectButtonStyleClass: "p-button-outlined",
            acceptIcon: "none",
            rejectIcon: "none",
            accept: () => data.ohYes(),
            reject: () => data.ohNo()
          });
    }
}